import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.625 1.5H9C9.99456 1.5 10.9484 1.89509 11.6517 2.59835C12.3549 3.30161 12.75 4.25544 12.75 5.25V7.125C12.75 8.161 13.59 9 14.625 9H16.5C17.4946 9 18.4484 9.39509 19.1517 10.0983C19.8549 10.8016 20.25 11.7554 20.25 12.75V20.625C20.25 21.66 19.41 22.5 18.375 22.5H5.625C5.12772 22.5 4.65081 22.3025 4.29917 21.9508C3.94754 21.5992 3.75 21.1223 3.75 20.625V3.375C3.75 2.339 4.59 1.5 5.625 1.5ZM11.9998 10.0332C14.1924 10.0332 11.9999 16.551 11.9999 16.551C11.9999 16.551 9.80732 10.0332 11.9998 10.0332ZM11.2495 17.8888C11.2495 17.4745 11.5853 17.1388 11.9995 17.1388H12.0065C12.4207 17.1388 12.7565 17.4745 12.7565 17.8888V17.8957C12.7565 18.31 12.4207 18.6457 12.0065 18.6457H11.9995C11.5853 18.6457 11.2495 18.31 11.2495 17.8957V17.8888Z"
        fill={colorValue}
      />
      <path
        d="M14.25 5.25C14.2518 3.98855 13.7975 2.76896 12.971 1.816C14.6443 2.25596 16.1707 3.13247 17.3941 4.35589C18.6175 5.5793 19.494 7.10571 19.934 8.779C18.981 7.95248 17.7615 7.49825 16.5 7.5H14.625C14.5255 7.5 14.4302 7.46049 14.3598 7.39016C14.2895 7.31984 14.25 7.22446 14.25 7.125V5.25Z"
        fill={colorValue}
      />
    </svg>
  );
};
